import { useEffect } from 'react';
import { ExpressCheckoutElement, PaymentElement } from '@stripe/react-stripe-js';
import { StripeExpressCheckoutElementClickEvent, StripePaymentElementChangeEvent } from '@stripe/stripe-js';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { CheckboxField, useFormField } from '@frontend/design-system';

interface StripePaymentMethodProps {
  isACH: boolean;
  onSaveChange: (value: boolean) => void;
  onSubmit: () => void;
  onPaymentChange: (type: string, isComplete: boolean) => void;
  shouldShowExpressElement?: boolean;
  shouldShowSavePaymentMethodOnFile?: boolean;
  paymentSuccessfullyCompleted?: boolean;
}

export const StripePaymentMethods = ({
  isACH,
  onSaveChange,
  onSubmit,
  onPaymentChange,
  shouldShowExpressElement,
  shouldShowSavePaymentMethodOnFile,
  paymentSuccessfullyCompleted,
}: StripePaymentMethodProps) => {
  const { t } = useTranslation('weave-pay');
  const shouldSavePaymentMethodOnFileFieldProps = useFormField({ type: 'checkbox' });

  const handleExpressElementChange = (event: StripeExpressCheckoutElementClickEvent) => {
    onPaymentChange(event.expressPaymentType, true);
    event.resolve();
  };

  const handlePaymentChange = (event: StripePaymentElementChangeEvent) => {
    onPaymentChange(event.value.type, event.complete);
  };

  useEffect(
    () => onSaveChange(shouldSavePaymentMethodOnFileFieldProps.value),
    [shouldSavePaymentMethodOnFileFieldProps.value]
  );

  return (
    <>
      {shouldShowExpressElement && (
        <ExpressCheckoutElement
          onClick={handleExpressElementChange}
          onConfirm={onSubmit}
          css={{ marginBottom: '24px' }}
        />
      )}
      <PaymentElement onChange={handlePaymentChange} options={{ readOnly: paymentSuccessfullyCompleted }} />
      {shouldShowSavePaymentMethodOnFile && (
        <CheckboxField
          css={{ marginTop: theme.spacing(3) }}
          {...shouldSavePaymentMethodOnFileFieldProps}
          name='paymentMethodOnfile'
          label={t(`Save ${isACH ? 'account' : 'card'} on file?`)}
          labelPlacement='right'
          disabled={paymentSuccessfullyCompleted}
        />
      )}
    </>
  );
};
